/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Radius Proxy API
 * # OpenAPI Specification
This API is documented in [OpenAPI v3.1.0](https://swagger.io/specification/) format.

# Authentication
The API supports two authentication methods:

# Error Responses
Whenever an error appears (whether it's a notifier bug which leads to an internal server error,
or a simple validation error) the API response will be in the
[Problem Details](https://tools.ietf.org/html/rfc7807) format

For example, a 404 response body would look like:
```json
{
    "status": 404,
    "type": "problems/resource-not-found",
    "title": "Resource not found",
    "detail": "Some entity with ID 'sdsada' does not exist."
}
```

# Subscriber Operations

## New Subscriber
Creates authentication data and assigns a speed profile based on USOC-to-group-name mapping.

## Suspend Subscriber
Adds a disable entry for the user with possible values: `non-payment`, `abuse`.

## Remove Suspension
Removes the disable entry to restore service.

## Upgrade/Downgrade Subscriber
Updates the assigned speed profile.

## Manage Static IPs (Idempotent)
Add or remove IP addresses assigned to the subscriber.

## Cancel Subscriber
Complete subscriber cancellation that removes authentication data, speed profile association,
all static IPs, and disable entries.

 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  CreateSpeedProfileBody,
  InternalServerErrorResponse,
  Problem,
  SpeedProfileWithUsocs,
  UISpeedProfilesListSpeedProfiles200,
  UnauthorizedResponse,
  UpdateSpeedProfileBody,
} from '.././model';

import { axiosInstance } from '.././axios-instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns all speed profiles from RADIUS database (`radgroupreply` table) with their associated USOCs.

Each speed profile contains:
- Input/Output attributes and values (bandwidth limits)
- List of associated USOC codes

**Data sources:**
- Speed profile attributes: RADIUS DB (`radgroupreply` table)
- USOC associations: Proxy DB (`usoc_speed_profile_mapping` table)

 * @summary List Speed Profiles
 */
export const uISpeedProfilesListSpeedProfiles = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal,
) => {
  return axiosInstance<UISpeedProfilesListSpeedProfiles200>(
    { url: `/ui/speed-profiles`, method: 'GET', signal },
    options,
  );
};

export const getUISpeedProfilesListSpeedProfilesQueryKey = () => {
  return [`/ui/speed-profiles`] as const;
};

export const getUISpeedProfilesListSpeedProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>, TError, TData>
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUISpeedProfilesListSpeedProfilesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>> = ({ signal }) =>
    uISpeedProfilesListSpeedProfiles(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UISpeedProfilesListSpeedProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>
>;
export type UISpeedProfilesListSpeedProfilesQueryError = UnauthorizedResponse | InternalServerErrorResponse;

export function useUISpeedProfilesListSpeedProfiles<
  TData = Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>,
          TError,
          Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUISpeedProfilesListSpeedProfiles<
  TData = Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>,
          TError,
          Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUISpeedProfilesListSpeedProfiles<
  TData = Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Speed Profiles
 */

export function useUISpeedProfilesListSpeedProfiles<
  TData = Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>,
  TError = UnauthorizedResponse | InternalServerErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesListSpeedProfiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUISpeedProfilesListSpeedProfilesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new speed profile with optional USOC associations.

**Operations performed:**
1. RADIUS DB: Inserts 2 rows into `radgroupreply` (input + output attributes)
2. Proxy DB: Creates USOC mappings in `usoc_speed_profile_mapping` (if USOCs provided)

**Default attributes:**
- `input_attribute`: `Vendor-Specific.NetElastic.Input-Average-Rate`
- `output_attribute`: `Vendor-Specific.NetElastic.Output-Average-Rate`

**Validation:**
- `groupname` must be unique (returns 409 if already exists)
- Each USOC must not be already assigned to another profile (returns 409 if duplicate)

 * @summary Create Speed Profile
 */
export const uISpeedProfilesCreateSpeedProfile = (
  createSpeedProfileBody: CreateSpeedProfileBody,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal,
) => {
  return axiosInstance<SpeedProfileWithUsocs>(
    {
      url: `/ui/speed-profiles`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSpeedProfileBody,
      signal,
    },
    options,
  );
};

export const getUISpeedProfilesCreateSpeedProfileMutationOptions = <
  TError = BadRequestResponse | UnauthorizedResponse | Problem | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uISpeedProfilesCreateSpeedProfile>>,
    TError,
    { data: CreateSpeedProfileBody },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uISpeedProfilesCreateSpeedProfile>>,
  TError,
  { data: CreateSpeedProfileBody },
  TContext
> => {
  const mutationKey = ['uISpeedProfilesCreateSpeedProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uISpeedProfilesCreateSpeedProfile>>,
    { data: CreateSpeedProfileBody }
  > = (props) => {
    const { data } = props ?? {};

    return uISpeedProfilesCreateSpeedProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UISpeedProfilesCreateSpeedProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uISpeedProfilesCreateSpeedProfile>>
>;
export type UISpeedProfilesCreateSpeedProfileMutationBody = CreateSpeedProfileBody;
export type UISpeedProfilesCreateSpeedProfileMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | Problem
  | InternalServerErrorResponse;

/**
 * @summary Create Speed Profile
 */
export const useUISpeedProfilesCreateSpeedProfile = <
  TError = BadRequestResponse | UnauthorizedResponse | Problem | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uISpeedProfilesCreateSpeedProfile>>,
      TError,
      { data: CreateSpeedProfileBody },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uISpeedProfilesCreateSpeedProfile>>,
  TError,
  { data: CreateSpeedProfileBody },
  TContext
> => {
  const mutationOptions = getUISpeedProfilesCreateSpeedProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves a single speed profile by groupname with its associated USOCs.

 * @summary Get Speed Profile
 */
export const uISpeedProfilesGetSpeedProfile = (
  groupname: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal,
) => {
  return axiosInstance<SpeedProfileWithUsocs>(
    { url: `/ui/speed-profiles/${groupname}`, method: 'GET', signal },
    options,
  );
};

export const getUISpeedProfilesGetSpeedProfileQueryKey = (groupname?: string) => {
  return [`/ui/speed-profiles/${groupname}`] as const;
};

export const getUISpeedProfilesGetSpeedProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>,
  TError = UnauthorizedResponse | Problem | InternalServerErrorResponse,
>(
  groupname: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUISpeedProfilesGetSpeedProfileQueryKey(groupname);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>> = ({ signal }) =>
    uISpeedProfilesGetSpeedProfile(groupname, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!groupname, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UISpeedProfilesGetSpeedProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>
>;
export type UISpeedProfilesGetSpeedProfileQueryError =
  | UnauthorizedResponse
  | Problem
  | InternalServerErrorResponse;

export function useUISpeedProfilesGetSpeedProfile<
  TData = Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>,
  TError = UnauthorizedResponse | Problem | InternalServerErrorResponse,
>(
  groupname: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>,
          TError,
          Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUISpeedProfilesGetSpeedProfile<
  TData = Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>,
  TError = UnauthorizedResponse | Problem | InternalServerErrorResponse,
>(
  groupname: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>,
          TError,
          Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUISpeedProfilesGetSpeedProfile<
  TData = Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>,
  TError = UnauthorizedResponse | Problem | InternalServerErrorResponse,
>(
  groupname: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Speed Profile
 */

export function useUISpeedProfilesGetSpeedProfile<
  TData = Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>,
  TError = UnauthorizedResponse | Problem | InternalServerErrorResponse,
>(
  groupname: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof uISpeedProfilesGetSpeedProfile>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUISpeedProfilesGetSpeedProfileQueryOptions(groupname, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a speed profile's attribute values and/or USOC associations.

**Partial updates supported:**
- Send only `usocs` to update USOC mappings (bulk replace)
- Send `input_value`, `output_value` to update bandwidth values
- Send all fields to update everything

**USOC update behavior (bulk replace):**
- All existing USOC mappings for this profile are deleted
- New mappings are created for all provided USOCs
- Each USOC must not be assigned to another profile

**Operations performed:**
1. RADIUS DB: Updates attribute values in `radgroupreply` (if provided)
2. Proxy DB: Replaces USOC mappings in `usoc_speed_profile_mapping` (if provided)

 * @summary Update Speed Profile
 */
export const uISpeedProfilesUpdateSpeedProfile = (
  groupname: string,
  updateSpeedProfileBody: UpdateSpeedProfileBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<SpeedProfileWithUsocs>(
    {
      url: `/ui/speed-profiles/${groupname}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateSpeedProfileBody,
    },
    options,
  );
};

export const getUISpeedProfilesUpdateSpeedProfileMutationOptions = <
  TError = BadRequestResponse | UnauthorizedResponse | Problem | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uISpeedProfilesUpdateSpeedProfile>>,
    TError,
    { groupname: string; data: UpdateSpeedProfileBody },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uISpeedProfilesUpdateSpeedProfile>>,
  TError,
  { groupname: string; data: UpdateSpeedProfileBody },
  TContext
> => {
  const mutationKey = ['uISpeedProfilesUpdateSpeedProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uISpeedProfilesUpdateSpeedProfile>>,
    { groupname: string; data: UpdateSpeedProfileBody }
  > = (props) => {
    const { groupname, data } = props ?? {};

    return uISpeedProfilesUpdateSpeedProfile(groupname, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UISpeedProfilesUpdateSpeedProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uISpeedProfilesUpdateSpeedProfile>>
>;
export type UISpeedProfilesUpdateSpeedProfileMutationBody = UpdateSpeedProfileBody;
export type UISpeedProfilesUpdateSpeedProfileMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | Problem
  | InternalServerErrorResponse;

/**
 * @summary Update Speed Profile
 */
export const useUISpeedProfilesUpdateSpeedProfile = <
  TError = BadRequestResponse | UnauthorizedResponse | Problem | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uISpeedProfilesUpdateSpeedProfile>>,
      TError,
      { groupname: string; data: UpdateSpeedProfileBody },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uISpeedProfilesUpdateSpeedProfile>>,
  TError,
  { groupname: string; data: UpdateSpeedProfileBody },
  TContext
> => {
  const mutationOptions = getUISpeedProfilesUpdateSpeedProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a speed profile and all its USOC associations.

**Deletion order:**
1. Proxy DB: Removes all USOC mappings from `usoc_speed_profile_mapping`
2. RADIUS DB: Deletes both attribute rows from `radgroupreply`

 * @summary Delete Speed Profile
 */
export const uISpeedProfilesDeleteSpeedProfile = (
  groupname: string,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<void>({ url: `/ui/speed-profiles/${groupname}`, method: 'DELETE' }, options);
};

export const getUISpeedProfilesDeleteSpeedProfileMutationOptions = <
  TError = UnauthorizedResponse | Problem | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uISpeedProfilesDeleteSpeedProfile>>,
    TError,
    { groupname: string },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uISpeedProfilesDeleteSpeedProfile>>,
  TError,
  { groupname: string },
  TContext
> => {
  const mutationKey = ['uISpeedProfilesDeleteSpeedProfile'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uISpeedProfilesDeleteSpeedProfile>>,
    { groupname: string }
  > = (props) => {
    const { groupname } = props ?? {};

    return uISpeedProfilesDeleteSpeedProfile(groupname, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UISpeedProfilesDeleteSpeedProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uISpeedProfilesDeleteSpeedProfile>>
>;

export type UISpeedProfilesDeleteSpeedProfileMutationError =
  | UnauthorizedResponse
  | Problem
  | InternalServerErrorResponse;

/**
 * @summary Delete Speed Profile
 */
export const useUISpeedProfilesDeleteSpeedProfile = <
  TError = UnauthorizedResponse | Problem | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uISpeedProfilesDeleteSpeedProfile>>,
      TError,
      { groupname: string },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uISpeedProfilesDeleteSpeedProfile>>,
  TError,
  { groupname: string },
  TContext
> => {
  const mutationOptions = getUISpeedProfilesDeleteSpeedProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
